<template>
    <!-- 我要退货页面（用户输入物流信息并提交退货） -->
    <div class="submit-return-wrapper">
         <div class="liquid-wrapper-outer">
             <div class="liquid-wrapper">
                <div class="each-title-wrapper">
                    <img :src="submitApplicationSrc" alt="submit-application.png">
                    <span>提交申请</span>
                </div>
                <div class="empty-border"></div>
                <div  class="each-title-wrapper">
                    <img :src="serviceReviewSrc" alt="service-review.png">
                    <span>客服审核</span>
                </div>
                <div class="empty-border"></div>
                <div class="each-title-wrapper">
                    <img :src="buyerPickUpSrc" alt="buyer-pick-up.png">
                    <span>买家提货</span>
                </div>
                <div class="empty-border"></div>
                <div class="each-title-wrapper">
                    <img :src="returnGoodsSrc" alt="return-goods.png">
                    <span>退货</span>
                </div> 
            </div>
            <div class="order-number">
                <span class="order-title">订单号</span>
                <span class="order-num">{{data.orderNo}}</span>
            </div>
        </div>
        <div class="order-card"
            v-cloak>
            <div class="goods-preview">
                <div class="detail-wra">
                    <div class="row1">{{data.productName}}</div>
                    <div class="row2" v-if="data.specName"><span 
                            class="mr25">规格：{{data.specName}}</span></div>
                     <div class="row3">
                        <span class="buy-title">购买数量</span>
                        <span class="buy-number"><span>￥</span>{{data.factFee}}<span class="multiplication">x</span>{{data.quantity}}份</span>
                    </div>
                </div>
            </div>
            <div class="each-row title">退款信息</div>
            <div class="each-row">
                <div class="left black">退货原因</div>
                <div class="right"
                    v-text="data.reasonCode == 5?data.reasonBody:reasonText[data.reasonCode]"></div>
            </div>
            <div class="each-row">
                <div class="left black"
                    :class="{'must-input':!isPass}">退款金额{{isPass?'':'：'}}</div>
                <div class="right"
                    v-if="isPass">
                    <span class="price">￥{{data.refundFee}}</span>
                </div>
                <div class="right"
                    v-else>
                    <van-field class="form-input"
                        type="number"
                        v-model="returnPrice"
                        :placeholder="'请输入退款金额，最多￥'+data.factFee" />
                </div>
            </div>
            <div class="each-row title">物流信息</div>
            <div class="each-row">
                <div class="left black"
                    :class="{'must-input':!isPass}">物流公司{{isPass?'':'：'}}</div>
                <div class="right"
                    v-if="isPass"
                    v-text="refundTransportCompany"></div>
                <div class="right"
                    v-else
                    @click.stop="$refs.select.openModal()"
                    :style="{color:liCompany?'#333333':'#B3B3B3'}">{{liCompany?liCompany:'请选择'}} 
                    <!-- <img class="right-icon"
                        src="https://oss.ygqhgw.com/assets/scene/png/right-icon.png"> -->
                    </div>
            </div>
            <div class="each-row">
                <div class="left black"
                    :class="{'must-input':!isPass}">退货单号{{isPass?'':'：'}}</div>
                <div class="right">
                    <span v-if="isPass">{{data.refundWaybillNo}}</span>
                    <van-field class="form-input"
                        v-else
                        type="text"
                        v-model="liNumber"
                        placeholder="请填写退货单号" />
                </div>
            </div>
            <div class="each-row title">退货地址</div>
            <div class="each-row"
                v-if="data.returnGoodsName">
                <div class="left">姓名</div>
                <div class="right"
                    v-text="data.returnGoodsName"></div>
            </div>
            <div class="each-row"
                v-if="data.returnGoodsTel">
                <div class="left">联系电话</div>
                <div class="right"
                    v-text="data.returnGoodsTel"></div>
            </div>
            <div class="each-row"
                v-if="data.returnGoodsAddress">
                <div class="left">详细地址</div>
                <div class="right"
                    v-text="data.returnGoodsAddress"></div>
            </div>
        </div>

        <div class="submit-btn"
            v-if="!isPass"
            @click="submit">确认退货</div>
        <div class="submit-btn"  
            v-if="isPass"
            @click="redirectToLi(data.refundWaybillNo,data.refundTransportCompany)">
            物流信息
        </div>
        <div class="submit-btn normal iphonex-adapt-margin"
            @click="cancelReturn">取消退货</div>
        
        <a-select title="选择物流公司"
            :columns="columns"
            @change="updateCompany"
            ref="select"></a-select>
    </div>
</template>

<script>
import ASelect from "@/components/common/ASelect.vue";
import EXPRESS from "@/js/express_code";
export default {
    name: "SubmitReturn",
    components: { ASelect },
    props: {
        // layouts: String,
        // layoutType: String,
    },
    data() {
        return {
            returnPrice: "", //退款金额
            liNumber: "", //物流单号
            columns: EXPRESS.map(e => e.company),
            liCompany: "",
            liCompanyCode: "",
            reasonText: [
                "",
                "商品有瑕疵",
                "买错了",
                "不喜欢了",
                "商品发错",
                "其他原因"
            ],
            data: {},
            returnLiquidSrc: "",
            rightIconSrc: "",
            isCostLoading:"",
            submitApplicationSrc:"",
            serviceReviewSrc:"",
            buyerPickUpSrc:"",
            returnGoodsSrc:""
        };
    },
    computed: {
        isPass() {
            //状态 标记客服是否通过了退货申请 通过的话这个页面做回显及查看物流的入口
            //有退货物流单号代表需要回显
            return !!this.data.refundWaybillNo;
        },
        refundTransportCompany() {
            if (!this.data.refundTransportCompany) return "";
            return EXPRESS.find(
                exp => exp.code === this.data.refundTransportCompany
            ).company;
        }
    },
    watch: {
        returnPrice(val) {
            if (val.indexOf(".") > -1) {
                let [left, right] = val.split(".");
                if (right.length > 2) {
                    this.returnPrice = left + "." + right.substr(0, 2);
                }
            }
        }
    },
    created() {
        if (sessionStorage.sReturn) {
            this.data = JSON.parse(sessionStorage.sReturn);
            this.returnPrice = this.data.factFee + "";
        }
    },
    mounted() {
        this.returnLiquidSrc = API.ossUrl + "order/png/return-liquid.png";
        this.rightIconSrc = API.ossUrl + "scene/png/right-icon.png";
        this.submitApplicationSrc = API.ossUrl + "order/png/submit-application.png";
        this.serviceReviewSrc = API.ossUrl + "order/png/service-review.png";
        this.buyerPickUpSrc = API.ossUrl + "order/png/buyer-pick-up.png";
        this.returnGoodsSrc = API.ossUrl + "order/png/return-goods.png";
    },
    destroyed() {},
    methods: {
        submit() {
            if (!this.returnPrice) {
                this.$alert("申请退款金额不能为空");
                return false;
            }
            if (!this.liCompanyCode) {
                this.$alert("请选择物流公司");
                return false;
            }
            if (!this.liNumber) {
                this.$alert("物流退货单号不能为空");
                return false;
            }

            if (this.returnPrice > this.data.factFee) {
                this.$alert("申请退款金额不能大于订单金额！");
                return false;
            }
            let body = {
                fee: this.returnPrice,
                waybillNo: this.liNumber,
                refundTransportCompany: this.liCompanyCode
            };
            this.$axios
                .put(
                    `${window.API.order.changeOrderStatus}/${
                        this.data.id
                    }?token=${sessionStorage.token}`,
                    body
                )
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.$toast("确认退货成功！");
                        this.$router.go(-1);
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch(err => console.log(err));
        },
        cancelReturn() {
            this.$confirm({
                content: "确定要取消退货吗？",
                yesText: "确定",
                noText: "取消"
            })
                .then(() => {
                    this.$axios
                        .put(
                            `${window.API.order.changeOrderStatus}/${
                                this.data.id
                            }?token=${sessionStorage.token}`
                        )
                        .then(({ data }) => {
                            if (data.code == 200) {
                                this.$toast("取消退货成功！");
                                this.$router.go(-1);
                            } else {
                                this.$toast(data.msg);
                            }
                        })
                        .catch(err => console.log(err));
                })
                .catch(e => console.log(e));
        },
        updateCompany(value) {
            let com = EXPRESS.find(e => e.company === value);
            if (com) {
                this.liCompany = value;
                this.liCompanyCode = com.code;
            }
        }
    }
};
</script>
<style scoped lang="scss">
.submit-return-wrapper {
    padding: 0.32rem 0.533333rem 0.373333rem;
    min-height: 100%;
     .liquid-wrapper-outer{
        margin: 0 auto;
        background: $white;
        padding: 0.32rem 0.373333rem 0.346667rem;
        box-shadow:0px 0.026667rem 0.066667rem 1px rgba(228,228,228,0.46);
        border-radius: 0.16rem;
        .liquid-wrapper {
            display: flex;
            .each-title-wrapper{
                width: 1.493333rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                img{
                    width: 0.8rem;
                    height: 0.8rem;
                    margin-bottom: 0.32rem; 
                    display: block;
                }
                span{
                    width: 1.493333rem;
                    text-align: center;
                    font-size: 0.373333rem;
                    font-family: PingFangSC-Medium;
                    font-weight: 500;
                    color: #444444 ;
                    line-height: 0.533333rem;
                }
            }
            .empty-border{
                margin-top: 0.373333rem;
                width: 0.933333rem;
                height: 0.053333rem;
                background: rgba(240,187,27,1);
                border-radius: 0.053333rem;
                opacity: 0.5647;
            }
            
        }
        .order-number {
            margin-top: 1.066667rem;
            font-size: 0.373333rem;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color: #444444;
            line-height: 0.533333rem;
            .order-title {
                margin-right: 0.373333rem;
            }
        }
    }
    .order-card {
        margin-top: 0.666667rem;
        background: $white;
        border-radius: 0.133333rem;
        box-shadow: 0 0 0.146667rem 0px rgba(0, 0, 0, 0.03);
        .each-row {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding-bottom: 0.4rem;
            &.title {
                font-size: 0.426667rem;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                color:#444444;
                line-height: 0.586667rem;
            }
            .left {
                color: $grey4;
                font-size: 0.426667rem;
                width: 30%;
                &.black {
                    color: #8c8c8c;
                }
            }
            .right {
                font-size: 0.426667rem;
                color: #8c8c8c;
                width: 70%;
                line-height: 0.586667rem;
                .right-icon {
                    margin-left: 0.186667rem;
                    width: 0.16rem;
                    height: 0.266667rem;
                }
                .price {
                    color: #8c8c8c;
                    font-size: 0.373333rem;
                }
                .form-input /deep/ {
                    padding: 0px;
                    min-width: 4.533333rempx;
                    input.van-field__control {
                        line-height: 0.64rem;
                        color: #8c8c8c;
                    }
                }
            }
        }
        .goods-preview {
            padding-top: 0.4rem;
            padding-bottom: 0.533333rem;
            display: flex;
            .preview {
                margin-right: 0.266667rem;
                width: 1.813333rem;
                height: 1.813333rem;
                border-radius: 0.133333rem;
            }
            .detail-wra {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .row1 {
                    font-size: 0.48rem;
                    font-family: PingFangSC-Semibold;
                    font-weight: 600;
                    color: #444444;
                    line-height: 0.666667rem;
                }
                 .row2 {
                    margin-top: 0.533333rem;
                    font-size: 0.426667rem;
                    font-family: PingFangSC-Regular;
                    font-weight:400;
                    color: #8c8c8c;
                    line-height: 0.586667rem;
                    .mr25{
                        color:#444444;
                        margin-left: 0.533333rem;
                    }
                }
                .row3 {
                    margin-top: 0.533333rem;
                    font-size: 0.426667rem;
                    font-family: PingFangSC-Regular;
                    font-weight:400;
                    color: #8c8c8c;
                    line-height: 0.586667rem;
                    .buy-number{
                        color:#444444;
                        margin-left: 0.533333rem;
                        span{
                            font-size: 0.32rem;
                        }
                        .multiplication{
                            font-size: 0.533333rem;
                        }
                    }
                }
                
            }
        }
        .each-block {
            background: $white;
             .detail-wra {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .row1 {
                    font-size: 0.48rem;
                    font-family: PingFangSC-Semibold;
                    font-weight: 600;
                    color:#444444;
                    line-height: 0.666667rem;
                }
                .row2 {
                    margin-top: 0.533333rem;
                    font-size: 0.426667rem;
                    font-family: PingFangSC-Regular;
                    font-weight:400;
                    color: #8c8c8c;
                    line-height: 0.586667rem;
                    .mr25{
                        color:#444444;
                        margin-left: 0.533333rem;
                    }
                }
                .row3 {
                    display: flex;
                    align-items: flex-start;
                    margin: 0.533333rem 0;
                    font-size: 0.426667rem;
                    font-family: PingFangSC-Regular;
                    font-weight:400;
                    color: #8c8c8c;
                    line-height: 0.586667rem;
                    .return-goods-address{
                        color:#444444;
                        margin-left: 0.533333rem;
                        display: inline-block;
                        word-break: break-all;
                        width: 6.693333rem;
                        span{
                            font-size: 0.32rem;
                        }
                        .multiplication{
                            font-size: 0.533333rem;
                        }
                    }
                    .mr25{
                        color:#444444;
                        margin-left: 0.533333rem;
                    }
                }
                .row3-special{
                    margin-bottom: 0;
                }
            }
            .each-row {
                display: flex;
                align-items: center;
                &:last-child {
                    margin-bottom: 0px;
                }
                .left {
                    color: #444444;
                    font-size: 0.426667rem;
                    font-family: PingFangSC-Semibold;
                    font-weight: 600;
                    line-height: 0.586667rem;
                }
                .right {
                    font-size: 0.426667rem;
                    line-height: 0.586667rem;
                    .price {
                        color: #444444;
                        font-size: 0.426667rem;
                        font-weight: bold;
                    }
                    .form-input /deep/ {
                        padding: 0px;
                        min-width: 4.533333rem;
                        input.van-field__control {
                            color: #444444;
                            font-size: 0.426667rem;
                        }
                    }
                }
            }
           
            .mb35 {
                margin-bottom: 0.466667rem;
            }
        }
    }  
    .submit-btn {
        width: 9.2rem;
        height: 1.2rem;
        border-radius: 0.6rem;
        background:linear-gradient(90deg,rgba(248,199,64,1) 0%,rgba(245,149,38,1) 100%);
        margin: auto;
        color: $white;
        font-size: 0.426667rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        &.normal {
            margin-top: 0.266667rem;
            background: transparent;
            color: #8c8c8c ;
            border: 1px solid rgba(151,151,151,1);
            box-shadow: 0 0 0 0 rgba(248, 199, 64, 0.49);
        }
    }
}
</style>
